"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
Object.defineProperty(exports, "CanvasTextMeasurer", {
  enumerable: true,
  get: function get() {
    return _CanvasTextMeasurer["default"];
  }
});

var _CanvasTextMeasurer = _interopRequireDefault(require("./CanvasTextMeasurer"));